import TischMitFiliale from "@/entities/common/tisch_mit_filiale"
import BaseLogic from "../base_logic"
import IdRequest from "@/entities/common/request/id_request"
import RemoteResult from "@/entities/common/remote_result"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BPBeginnenSofortRequest from "@/entities/common/pending/bp_beginnen_sofort_request"
import vuexStore from "@/store"
import BestellungPending from "@/entities/common/bestellung_pending"
import { Terminart } from "@/entities/common/enums"
import router from "@/router"
import RouteNames from "@/util/route_names"
import BestellungFilialeRequest from "@/entities/common/request/bestellung_filiale_request"
import BestellungList from "@/entities/common/lists/bestellung_list"
import Bestellung from "@/entities/common/bestellung"

export default class TischbestellungStartenLogic extends BaseLogic {
  tisch: TischMitFiliale
  aktuelleBestellungen: Bestellung[] = []

  init(tischId: string) {
    var request = new IdRequest()
    request.id = tischId

    Poster.postUser<RemoteResult<TischMitFiliale>>(
      RestPaths.filialeDetailsMitTisch,
      request
    ).then((response) => {
      if (response.data.success) {
        this.tisch = response.data.payload
      }
    })

    var bestellungRequest = new BestellungFilialeRequest()
    bestellungRequest.identifierId = vuexStore.state.user.identifier
    bestellungRequest.filialeId = this.mainLogic.filiale.filialeId

    Poster.postUser<RemoteResult<BestellungList>>(
      RestPaths.bestellungKundeFilialeAktuell,
      bestellungRequest
    ).then((response) => {
      if (response.data.success) {
        this.aktuelleBestellungen = response.data.payload.list
      }
    })
  }

  bestellungStarten() {
    var request = new BPBeginnenSofortRequest()
    request.tischId = this.tisch.tisch.id
    request.personen = 2
    request.identifier = vuexStore.state.user.identifier

    Poster.postUser<RemoteResult<string>>(
      RestPaths.bestellungpendingBeginnenSofort,
      request
    ).then((response) => {
      if (response.data.success) {
        this.mainLogic.bestellungPending = new BestellungPending()
        this.mainLogic.bestellungPending.terminart = Terminart.SOFORTBESTELLUNG
        this.mainLogic.bestellungPending.sofort.tischId = this.tisch.tisch.id
        this.mainLogic.bestellungPending.sofort.tischBezeichnung =
          this.tisch.tisch.tischnummer
        this.mainLogic.neueBestellung = true

        router.push({
          name: RouteNames.NEU.SOFORTBESTELLUNG_BESTELLART,
        })
      }
    })
  }

  bestellungAnzeigen(bestellung: Bestellung) {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { bestellungId: bestellung.id },
    })
  }
}
